import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SigninPaymentGateContainer from "../shared_components/signin_payment_gate_container";
import { SigninSection } from "./signin_section";
import { chAnalyticsTrackEvent } from "../analytics";

import toolsOverlayStyles from "../signin_gates/discussion_tools_overlay.module.scss";

interface Props {
  googleClientId: string;
  cleverUrl: string;
  clipThumbnailUrl: string;
  containerClass?: string;
}

const ANALYTICS_FEATURE_NAME = "vocabulary_finder";

function VocabularyFinderSigninGate(props: Props) {
  useEffect(() => {
    const args = { feature: ANALYTICS_FEATURE_NAME, label: "hit_signin_gate" };

    chAnalyticsTrackEvent("signin_gate", args);
  }, []);

  const onLinkClick = (e) => {
    const args = {
      feature: ANALYTICS_FEATURE_NAME,
      label: "click_signin_gate",
      link: e.currentTarget.href
    };

    chAnalyticsTrackEvent("signin_gate", args);
  };

  return (
    <SigninPaymentGateContainer
      containerClass={props.containerClass}
    >
      <SigninPaymentGateContainer.LeftSide className="p-4">
        <>
          <h4>Sign in to use Vocabulary Finder</h4>

          <p className="mt-4">
            Make vocabulary visual: easily find vocabulary words and phrases within scenes from TV shows and movies.
          </p>

          <ul>
            <li>Improve understanding of vocabulary through contextual, authentic examples.</li>
            <li>Help students hear and practice pronunciation.</li>
            <li>Easily find more examples of vocabulary used in sentences and phrases.</li>
          </ul>

          <div className="mt-5">
            <SigninSection
              googleClientId={props.googleClientId}
              cleverUrl={props.cleverUrl}
              onLinkClick={onLinkClick}
              buttonWidth={300}
            />
          </div>
        </>
      </SigninPaymentGateContainer.LeftSide>

      <SigninPaymentGateContainer.RightSide>
        <div className="d-flex justify-content-center h-100 pt-5">
          <div className={classNames(toolsOverlayStyles.backgroundContainer)}>
            <div className="p-4">
              <h5 className="text-center">Vocabulary Finder</h5>

              <div className="input-group w-50 mt-4 mx-auto">
                <input type="text" className="form-control text-center" defaultValue="experiment" tabIndex={-1} />

                <button type="button" className="btn btn-dark" tabIndex={-1}>
                  <FontAwesomeIcon icon="search" />
                </button>
              </div>

              <div className="mt-4 text-center">
                <img
                  src={props.clipThumbnailUrl}
                  className={classNames("rounded", toolsOverlayStyles.thumbnail)}
                  width="100%"
                  alt="Video thumbnail"
                />
              </div>

              <div className="mt-3 text-center">
                <div className="fw-bold">
                  <a href="#" tabIndex={-1}>00:45</a>
                </div>

                <div className="font-italic">
                  ...he proposed an <span className="fw-bold">experiment</span> where a cat...
                </div>
              </div>

              <div className="mt-3 text-center">
                <div className="fw-bold">
                  <a href="#" tabIndex={-1}>01:30</a>
                </div>

                <div className="font-italic">
                  ...tampered with the results of his <span className="fw-bold">experiment</span>
                  ...
                </div>
              </div>
            </div>
          </div>
        </div>
      </SigninPaymentGateContainer.RightSide>
    </SigninPaymentGateContainer>
  );
}

export function renderVocabularyFinderSigninGate(elementId, options) {
  const node = ReactDOM.render(
    <VocabularyFinderSigninGate
      googleClientId={options.googleClientId}
      cleverUrl={options.cleverUrl}
      clipThumbnailUrl={options.clipThumbnailUrl}
      containerClass={options.containerClass}
    />,
    document.getElementById(elementId)
  );

  return node;
}